import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './WhatsAppThankYou.css';
import { initializeThankYou } from '../thankYouScript.js';

const WhatsAppThankYou = () => {
  useEffect(() => {
    // Add meta tags to head
    const offerMeta = document.createElement('meta');
    offerMeta.name = 'offer';
    offerMeta.content = 'WhatsApp Access';
    document.head.appendChild(offerMeta);

    // Initialize call booking
    try {
      initializeThankYou();
      console.log('Call booking initialized successfully');
    } catch (error) {
      console.error('Error initializing call booking:', error);
    }

    // Cleanup function
    return () => {
      if (document.querySelector('meta[name="offer"]')) {
        document.querySelector('meta[name="offer"]').remove();
      }
    };
  }, []);

  return (
    <div className="whatsapp-thank-you-container">
      <div className="thank-you-content">
        <div className="success-icon">
          💬 ✅
        </div>
        <h1>Welcome to WhatsApp Access!</h1>
        <p>Your subscription is confirmed. You now have unlimited access to Tuomas on WhatsApp.</p>
        
        <div className="next-steps">
          <h3>How to Get Started</h3>
          <ul>
            <li>Add Tuomas on WhatsApp: <strong>+971 56 498 2660</strong></li>
            <li>Introduce yourself and mention your subscription</li>
            <li>Start asking your questions about relocation, visas, business setup, and more</li>
            <li>Expect responses within 24 hours (usually faster)</li>
          </ul>
        </div>

        <div className="whatsapp-button-container">
          <a 
            href="https://wa.me/971564982660?text=Hi%20Tuomas,%20I%20just%20subscribed%20to%20WhatsApp%20Access!" 
            className="whatsapp-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open WhatsApp Now
          </a>
        </div>

        <div className="additional-resources">
          <h3>Explore More Resources</h3>
          <p>Check out our guides and services while you're here:</p>
          <div className="resource-links">
            <Link to="/relocation-services" className="resource-link">
              View All Services
            </Link>
            <Link to="/uae" className="resource-link">
              UAE Setup Guide
            </Link>
            <Link to="/mexico-residency" className="resource-link">
              Mexico Residency
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsAppThankYou;
